import { map, catchError, mergeMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Observable, of } from 'rxjs';


import * as CustomersActions from './customers.actions';

@Injectable()
export class CustomersEffects {
    getAllAgents$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CustomersActions.GET_ALL_CUSTOMERS),
            map(reports => {
                if (reports) {
                    return Observable.create({});
                }
            }),
            catchError(err => of(CustomersActions.error({ error: err.message })))
        )
    );

    constructor(
        private actions$: Actions
    ) {}
}